import { useNotification } from '../../../../../../../hooks'
import { postMockApplicantCreditCheckResult } from '../../../../../../RentalPortalApplicant'
import { useApplicantProfileContext } from '../../../../RentalPortalApplicantProfile.hooks'
import { getIsApplicantCreditCheckCorrection } from '../../ApplicantCreditCheckBlock.utils'
import { ApplicantCreditCheckVerdictModal } from '../../ApplicantCreditCheckVerdictModal'

export function useApplicantCreditCheckVerdict() {
  const { handleAddSuccessNotification } = useNotification()

  const { applicantId, handleCloseModal, handleEntityReload, setModal } =
    useApplicantProfileContext()

  async function submitVerdict({ isCorrection, values }) {
    await postMockApplicantCreditCheckResult({
      applicantId,
      isCorrection,
      values,
    })

    await handleEntityReload().catch(console.error)

    handleCloseModal()

    handleAddSuccessNotification('Notification.CommonTitleSavedKey')
  }

  function handleOpenVerdictForm(action, extraction) {
    setModal(
      <ApplicantCreditCheckVerdictModal
        extraction={extraction}
        isCorrection={getIsApplicantCreditCheckCorrection(action)}
        onClose={handleCloseModal}
        onSubmit={submitVerdict}
      />
    )
  }

  return { handleOpenVerdictForm }
}
